if (!customElements.get('size-guide-toggle')) {
  customElements.define(
    'size-guide-toggle',
    class SizeGuideToggle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.buttons = Array.from(this.querySelectorAll('[data-unit]'));
        this.onClick = this.onClick.bind(this);
        this.buttons.forEach((button) => button.addEventListener('click', this.onClick));

        this.setUnit(this.dataset.defaultUnit === 'in' ? 'in' : 'cm');
      }

      disconnectedCallback() {
        if (!this.buttons) return;
        this.buttons.forEach((button) => button.removeEventListener('click', this.onClick));
        delete this.dataset.initialized;
      }

      onClick(event) {
        this.setUnit(event.currentTarget.dataset.unit);
      }

      setUnit(unit) {
        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.unit === unit ? 'true' : 'false');
        });

        this.querySelectorAll('[data-cm][data-in]').forEach((el) => {
          el.textContent = unit === 'in' ? `${el.dataset.in}in` : `${el.dataset.cm}cm`;
        });
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('size-guide-toggle').forEach((el) => {
    if (el.dataset.initialized !== 'true' && typeof el.connectedCallback === 'function') {
      el.connectedCallback();
    }
  });
});
